import { render, staticRenderFns } from "./editNewsletter.vue?vue&type=template&id=178d9ce5&"
import script from "./editNewsletter.vue?vue&type=script&lang=js&"
export * from "./editNewsletter.vue?vue&type=script&lang=js&"
import style0 from "./editNewsletter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports